import React from 'react';
import { navigationArrows } from '../../../components/shared/vector-images';
import Text from '../../../components/shared/_deprecated/elements/Text/Text';
import {
  onInitializeStandardMarker,
  onToggleStandardMarker,
} from '../_helpers';

const layer = {
  displayName: 'Navigation information',
  synonyms: '',
  group: 'standardMarker',
  typeUrl: 'navigation-information',
  icon: {
    baseShape: navigationArrows,
    iconColor: '#fff',
    markerColor: '#139ECA',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: true,
    owningMenu: 'marine-points-of-interest',
    order: 1000,
  },
  standardMarkerOptions: {
    markerType: 'navigationInformationMarker',
    allowCreation: true,
    allowEditing: false,
    allowComments: true,
    viewOptions: {
      typeTitle: 'Navigation information',
      itemTitleFunction: (item) =>
        (item && item.title) || 'Navigation information',
    },
    creationOptions: {
      menuText: 'Navigation information',
      newTitle: 'Navigation information',
      titlePlaceholder: 'Name of marker',
      markerTypeDescription: [
        <Text key="description-text-1" size="-1" paragraph>
          This marker can indicate various types of navigation assistance.
          Include information such as factors to be aware of, potential
          concerns, or any caution to be advised.
        </Text>,
        <Text key="description-text-2" size="-1" paragraph>
          Information provided should be factual. Once you submit this marker,
          you can add your personal experiences or questions as a comment
          underneath.
        </Text>,
      ],
      checkBoxItems: [],
    },
    editingOptions: {},
  },
  popOverConfiguration: (marker) => ({
    markerType: layer.standardMarkerOptions.markerType,
    id: marker.id,
    displayChat: true,
    displayUpVotes: true,
    title: 'Navigation information',
    description: marker.title,
  }),
};

layer.onInitialize = onInitializeStandardMarker(layer);
layer.onToggle = onToggleStandardMarker(layer);

export default layer;
